import { format } from 'date-fns'

export const formatDate = ( date: string | null | undefined, fallback: string ): string => {
	if ( !date ) {
		return fallback
	}

	return format( date, 'MMM d, yyyy, h:mm a' )
}
